/**
 * Escapes special regex characters in a string to make it safe for use in regular expressions.
 *
 * @param {string} str - The string to escape regex special characters in.
 * @returns {string} The string with regex special characters escaped.
 */
export const escapeRegex = (str: string) => str.replace(/[\\^$.*+?()[\]{}|%]/g, String.raw`\$&`);
